<template>
  <div class="white-wrapper">
    <div class="section-title">
      {{ $t("Daily Cashup Report") }}
    </div>
    <div class="mt-3 mb-2">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
        ? 'shift-up'
        : ''
        ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
            <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
              :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
              @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
              <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                v-validate="'required'"></Datepicker>
              <label :class="fromDate ? 'active' : ''">
                <!-- {{ $t("show") }} -->
                {{ $t("fromdate") }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="input-material">
            <div class="add-datepicker">
              <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
              <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" v-validate="'required'">
              </Datepicker>
              <label :class="toDate ? 'active' : ''">
                <!-- {{ $t("show") }}  -->
                {{ $t("todate") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-3">
          <button class="btn-blue-lg w-100" @click.prevent="GetDailyCashupReportReport('N')">
            {{ $t("fetch") }}
            {{ $t("report") }}
          </button>
        </div>
      </div>
    </div>

    <div class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center">
      <div class="mx-1">{{ $t("download") }} as:</div>
      <!-- s -->
      <a target="_blank" @click="GetDailyCashupReportReport('Y')" title="Download as PDF" download>
        <img class="mx-1" src="@/assets/img/icons/pdf.svg" height="25" width="25" />
      </a>
    </div>

    <div>
      <div class="table-scroll">
        <table slot="pdf-content" class="swc-report-table swc_table_header" border="1">
          <template>
            <thead>
              <tr>
                <th colspan="2" class="text-left">Revenue</th>
              </tr>
            </thead>
            <template>
              <tbody v-if="Object.keys(boxOfficeCashUp).length">
                <tr>
                  <th colspan="2" class="pt-4 text-left">Box Office</th>
                </tr>
                <tr>
                  <td class="text-left">Gross Box Office</td>
                  <td class="data">{{ currFormat(boxOfficeCashUp.gross_bo + boxOfficeCashUp.less_maturing_sales) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Less Redemptions</td>
                  <td class="data">{{ currFormat(boxOfficeCashUp.less_redemptions) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Less Maturing Sales</td>
                  <td class="data">{{ -currFormat(boxOfficeCashUp.less_maturing_sales) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Plus Advance Sales</td>
                  <td class="data">{{ currFormat(boxOfficeCashUp.plus_advance_sales) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Plus Advance Comps and Redemptions</td>
                  <td class="data">{{ currFormat(boxOfficeCashUp.plus_advance_redemptions_and_comps) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Box Office Receipts</td>
                  <th class="text-right  total_value_1">{{
        currFormat(boxOfficeCashUp.gross_bo + boxOfficeCashUp.less_maturing_sales -
          boxOfficeCashUp.less_redemptions -
          boxOfficeCashUp.less_maturing_sales + boxOfficeCashUp.plus_advance_sales +
          boxOfficeCashUp.plus_advance_redemptions_and_comps)
      }}</th>
                </tr>
              </tbody>
            </template>

            <template>
              <tbody v-if="sundryData.length">
                <tr>
                  <th colspan="3" class="pt-4 text-left">Box Office Sundry</th>
                </tr>
                <tr v-for="(saledata, index) in sundryData" :key="index">
                  <td class="text-left">{{ saledata.offer_name }}</td>
                  <td>{{ currFormat(saledata.offer_price) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Total Box Office Sundry </td>
                  <th class="text-right total_value_1">{{ currFormat(sundryData.reduce((acc, { offer_price }) => {
        return acc + offer_price
      }, 0)) }}</th>
                </tr>

              </tbody>
            </template>

            <template>
              <tbody v-if="fnbCategoryData.length">
                <tr>
                  <th colspan="3" class="pt-4 text-left">Concessions</th>
                </tr>
                <tr v-for="(saledata, index) in fnbCategoryData" :key="index">
                  <td class="text-left">{{ saledata.category_name }}</td>
                  <td>{{ currFormat(saledata.total_amount) }}</td>
                </tr>

                <tr>
                  <td class="text-left">Total Concessions</td>
                  <th class="text-right total_value_1"> {{
        fnbCategoryData.reduce(
          (acc, { total_concessions }) => {
            return acc + total_concessions;
          },
          0
        )
      }} </th>
                </tr>
                <tr>
                  <th class="text-left">Total Sales</th>
                  <th class="text-right total_value_1">{{ currFormat(fnbCategoryData.reduce(
        (acc, { total_amount }) => {
          return acc + total_amount;
        },
        0
      )) }}</th>
                </tr>
              </tbody>
            </template>

            <template>
              <tbody v-if="workStationData.length">
                <tr>
                  <th colspan="3" class="pt-4 text-left">Sales Reconciliation by Workstation Group</th>
                </tr>
                <tr v-for="(saledata, index) in workStationData" :key="index">
                  <td class="text-left">{{ saledata.location_name }}</td>
                  <td>{{ currFormat(saledata.total_amount) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Total Sales Reconciliation</td>
                  <th class="text-right total_value_1">{{
        currFormat(workStationData.reduce(
          (acc, { total_amount }) => {
            return acc + total_amount;
          },
          0
        ))
      }}</th>
                </tr>
                <tr>
                  <th class="text-left">Total Expected Receipts</th>
                  <th class="text-right  total_value_1">{{
          currFormat(workStationData.reduce(
            (acc, { total_amount }) => {
              return acc + total_amount;
            },
            0
          ))
        }}</th>
                </tr>

              </tbody>
            </template>
          </template>


          <template>
            <thead>
              <tr>
                <th colspan="3" class="pt-4 text-left">Reconciliation</th>
              </tr>
            </thead>
            <template>
              <tbody v-if="nonBankingData.length">
                <tr>
                  <th colspan="2" class="pt-4 text-left">Less Non Banking</th>
                </tr>
                <tr v-for="(nonBankingData, index) in nonBankingData" :key="index">
                  <td class="text-left">{{ nonBankingData.pm_payment_mode }}</td>
                  <td class="data">{{ currFormat(nonBankingData.total_amount) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Total Non-Banking</td>
                  <th class="text-right  total_value_1">{{
        currFormat(nonBankingData.reduce(
          (acc, { total_amount, booking_fee = 0 }) => {
            return acc + total_amount;
          },
          0
        ))
      }} </th>
                </tr>
              </tbody>
            </template>

            <template>
              <tbody v-if="bankingData.length">
                <tr>
                  <th colspan="2" class="pt-4 text-left">Expected Banking</th>
                </tr>
                <tr v-for="(BankingData, index) in bankingData" :key="index">
                  <td class="text-left">{{ BankingData.pm_payment_mode }}</td>
                  <td>{{ currFormat(BankingData.total_amount) }}</td>
                </tr>
                <tr>
                  <td class="text-left">Total Expected Banking</td>
                  <th class="text-right total_value_1">{{
                    currFormat(bankingData.reduce(
                    (acc, { total_amount, }) => {
                    return acc + total_amount;
                    },
                    0
                    ))
                    }}</th>
                </tr>
              </tbody>
            </template>

          </template>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1
        },
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape"
        }
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      boxOfficeCashUp: {},
      fnbCategoryData: [],
      sundryData: [],
      workStationData: [],
      dailyCashupData: {},
      concessionData: [],
      nonBankingData: [],
      bankingData: [],
      offerData: [],
      work_station_data: [],
      finalExperienceArray: [],
      boxOfficeSundryTotal: 0,
      Total_Sales: 0
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {

  },
  mounted() { },
  methods: {
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetDailyCashupReportReport(isPdf = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf
      };
      ReportsService.GetDailyCashupReportReport(payload)
        .then((response) => {
          const { data } = response;

          if (data.status && Object.keys(data.Records).length) {


            this.boxOfficeCashUp = data.Records.boxOffice
            this.fnbCategoryData = data.Records.fnbCategoryData
            this.sundryData = data.Records.sundry
            this.workStationData = data.Records.workStationSales

            if (data.Records.paymentWiseSales.length) {
              this.nonBankingData = data.Records.paymentWiseSales.filter(paymentObj => {
                return !["1", "12", "13", "isRedemptions"].includes(String(paymentObj.pm_id))
              })
              this.bankingData = data.Records.paymentWiseSales.filter(paymentObj => {
                return ["1", "12", "13", "isRedemptions"].includes(String(paymentObj.pm_id))
              })
            }


            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }

        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>


<style scoped>
tr {
  border: transparent;
}

.total_value_1 {
  border-top: solid black 1px;
}

.data {
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dailyCashupReport.vue